// src/styles/typography/fonts.js
/**
 * Font family configurations
 * These match your CSS variables
 */

export const fontFamilies = {
  primary: "var(--font-family-primary, 'Fira Sans', sans-serif)",
  //secondary: "'Roboto', sans-serif",
  //mono: "'Courier New', monospace",
  //display: "'Playfair Display', serif",
  //handwritten: "'Caveat', cursive",
};

// Simple function that returns the CSS variable
export const getFontFamily = () => {
  // In browser, try to get the CSS variable value
  if (typeof window !== "undefined") {
    try {
      const cssVar = getComputedStyle(document.documentElement)
        .getPropertyValue('--font-family-primary')
        .trim();
      
      if (cssVar) {
        return cssVar;
      }
    } catch {
      // Silently fail
    }
  }
  
  // Fallback to the CSS variable syntax
  return fontFamilies.primary;
};

// Get font family by key
export const getFontFamilyByKey = (key) => {
  if (key === 'primary') {
    return getFontFamily();
  }
  return fontFamilies[key] || fontFamilies.primary;
};

// Check if font is available
export const isFontAvailable = (fontFamily) => {
  return Object.values(fontFamilies).some(family => 
    family.includes(fontFamily) || fontFamily.includes(family)
  );
};

// No need for loadGoogleFonts since CSS handles it!